<template>
  <div class="history">
    <div class="history__top">
      <h2 class="history__top--title">
        {{ getTranslatedText("Transaction History") }}
      </h2>
      <div class="history__top--search_ref">
        <span>{{ getTranslatedText("Search Ticket ID:") }}</span>
        <input type="text" v-model="ticketID" @input="handleInputSearch" />
      </div>
      <div class="history__top--search_date">
        <label>{{ getTranslatedText("Select Date:") }}</label>
        <DatePicker :title="'From'" v-model="dateFrom" />
        <DatePicker :title="'To'" v-model="dateTo" />
      </div>
      <div class="history__top--button">
        <ButtonCommon :isNoHover="true" text="Search" @action-button="actionSearch()" :isLoading="isLoadingSearch"
          :isDisable="isDisableSearch" />
      </div>
    </div>
    <div class="history__filter">
      <div class="history__filter--des">
        <span v-if="!$store.state.isScreenMobile">{{ getTranslatedText("Filter") }}</span>
        <Select :label="$store.state.isScreenMobile ? 'Filter Description' : 'Description'" :items="itemsDescription"
          v-model="filterDescription" :isRenderCustom="true" />
        <ButtonCommon :isNoHover="true" text="Filter" @action-button="actionFilter()" :isLoading="isLoadingFilter"
          :isDisable="!filterDescription" />
        <ButtonCommon :isNoHover="true" text="reset filter" @action-button="resetFilter()"
          :isDisable="!filterDescription && isDisableSearch" />
      </div>
    </div>
    <Loading v-if="isLoadingScreens" />
    <div class="history__wrap__content" v-else-if="this.dataHistory.length !== 0 && !isLoadingScreens">
      <div class="history__header" v-if="!$store.state.isScreenMobile">
        <p class="history__header--type"></p>
        <p class="history__header--ref">{{ getTranslatedText("ticket id") }}</p>
        <p class="history__header--date">{{ getTranslatedText("draw date") }}</p>
        <p class="history__header--product">
          {{ getTranslatedText("Product Type") }}
        </p>
        <p class="history__header--bet">{{ getTranslatedText("Bet Type") }}</p>
        <p class="history__header--number">{{ getTranslatedText("Numbers Selected ") }}</p>
        <p class="history__header--cost">
          {{ getTranslatedText("Cost") }}
        </p>
        <p class="history__header--des">
          {{ getTranslatedText("Description") }}
        </p>
        <p class="history__header--status">{{ getTranslatedText("Status") }}</p>
        <p class="history__header--print"></p>
      </div>
      <div class="history__content">
        <div v-for="(item, index) in dataHistory" :key="index">
          <div class="history__content--wrap">
            <div v-if="item.ticket_type_slug === 'singlebet'">
              <div class="history__content--main">
                <p class="history__content--type">
                  {{ getTranslatedText("Single Bet") }}
                </p>
                <p class="history__content--ref">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("ticket id") }}</span>
                  <span>{{ item.ticket_id }}</span>
                </p>
                <p class="history__content--date">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("draw date") }}</span>
                  <span>{{ $helpers.formatDateTime(item.bets[0].draw_date) }}</span>
                </p>
                <p class="history__content--product">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Product Type") }}</span>
                  <span>{{ getTranslatedText(item.bets[0].product_type) }}</span>
                </p>
                <p class="history__content--bet">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Bet Type") }}</span>
                  <span>{{ getTranslatedText(item.bets[0].bet_type) }}</span>
                </p>
                <p class="history__content--number">
                  <span class="number_title" v-if="$store.state.isScreenMobile">
                    {{ getTranslatedText("Numbers selected") }}
                  </span>
                <ul>
                  <template v-if="(typeof item.bets[0].select[0] !== 'string')">
                    <li v-for="(number, i) in item.bets[0].select[0]" :key="i">{{ number }}</li>
                  </template>
                  <template v-else>
                    <li class="none-circle">{{ item.bets[0].select[0] }}</li>
                  </template>
                </ul>
                </p>
                <p class="history__content--cost">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Cost") }}</span>
                  <span>{{ renderPrice(item.total_wager) }}</span>
                </p>
                <p class="history__content--des">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Description") }}</span>
                  <span>{{ item.description }}</span>
                </p>
                <p class="history__content--status">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Status") }}</span>
                  <span>{{ getTranslatedText(item.status) }}
                    <span v-if="item.re_print" class="history_prin" @click.stop=""
                      @click="onReprintClicked(item.transaction_id)">
                      <img src="~ThemePath/images/icon/icon_print.png" alt="print" />
                    </span>
                  </span>
                </p>
              </div>
            </div>
            <div v-if="$store.state.isScreenMobile && item.ticket_type_slug === 'multibet'">
              <div class="history__content--main">
                <div class="multibet">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <p class="history__content--type">
                          {{ getTranslatedText("Multibet") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="multibet__item" v-for="(value, i) in item.bets" :key="i">
                          <div class="multibet__content--left">
                            <p>{{ $helpers.formatDateTime(value.draw_date) }}</p>
                            <p>{{ getTranslatedText(value.product_type) }}</p>
                            <p>{{ getTranslatedText(value.bet_type) }}</p>
                          </div>
                          <div class="multibet__content--right">
                            <ul>
                              <template v-if="(typeof value.select[0]) !== 'string'">
                                <li v-for="(number, i) in value.select[0]" :key="i">{{ number }}</li>
                              </template>
                              <template v-else>
                                <li class="none-circle">{{ value.select[0] }}</li>
                              </template>
                            </ul>
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <p class="history__content--ref">
                  <span>{{ getTranslatedText("ticket id") }}</span>
                  <span>{{ item.ticket_id }}</span>
                </p>
                <p class="history__content--cost">
                  <span>{{ getTranslatedText("Cost") }}</span>
                  <span>{{ renderPrice(item.total_wager) }}</span>
                </p>
                <p class="history__content--des">
                  <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Description") }}</span>
                  <span>{{ item.description }}</span>
                </p>
                <p class="history__content--status">
                  <span>{{ getTranslatedText("Status") }}</span>
                  <span>{{ getTranslatedText(item.status) }}
                    <span v-if="item.re_print" class="history_prin" @click="onReprintClicked(item.transaction_id)">
                      <img src="~ThemePath/images/icon/icon_print.png" alt="print" />
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="multibet" v-if="!$store.state.isScreenMobile && item.ticket_type_slug === 'multibet'">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <p class="history__content--type">
                    <span>{{ getTranslatedText("Multibet") }}</span>
                  </p>
                  <p class="history__content--ref">
                    <span>{{ item.ticket_id }}</span>
                  </p>
                  <p class="empty_area"></p>
                  <p class="history__content--cost">
                    <span>{{ renderPrice(item.total_wager) }}</span>
                  </p>
                  <p class="history__content--des">
                    <span v-if="$store.state.isScreenMobile">{{ getTranslatedText("Description") }}</span>
                    <span>{{ item.description }}</span>
                  </p>
                  <p class="history__content--status">
                    <span>{{ getTranslatedText(item.status) }}
                      <span v-if="item.re_print" class="history_prin" @click.stop=""
                        @click="onReprintClicked(item.transaction_id)">
                        <img src="~ThemePath/images/icon/icon_print.png" alt="print" />
                      </span>
                    </span>
                  </p>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="history__content--main" v-for="(value, i) in item.bets" :key="i">
                    <p class="history__content--type"></p>
                    <p class="history__content--ref">
                    </p>
                    <p class="history__content--date">
                      {{ $helpers.formatDateTime(value.draw_date) }}
                    </p>
                    <p class="history__content--product">
                      {{ getTranslatedText(value.product_type) }}
                    </p>
                    <p class="history__content--bet">
                      {{ getTranslatedText(value.bet_type) }}
                    </p>
                    <p class="history__content--number">
                    <ul>
                      <template v-if="(typeof value.select[0] !== 'string')">
                        <li v-for="(number, i) in value.select[0]" :key="i">{{ number }}</li>
                      </template>
                      <template v-else>
                        <li class="none-circle">{{ value.select[0] }}</li>
                      </template>
                    </ul>
                    </p>
                    <p class="history__content--cost"></p>
                    <p class="history__content--des"></p>
                    <p class="history__content--status"></p>
                    <p class="history__content--print"></p>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </div>

    <div class="history_empty" v-else>
      <p>{{ getTranslatedText('Your History Is Empty') }}</p>
    </div>
    <div class="history__list_page">
      <Pagination :totalPages="total_page" :currentPage="current_page" @page-change="handlePageChange"></Pagination>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import printMixins from "@/mixins/print/print-mixins";
import ButtonCommon from "@/components/common/button";
import DatePicker from "@/components/common/datepicker";
import { formatPrice } from "@/utils/utils";
import HistoryService from "@/services/history.service";
import Pagination from "@/components/common/pagination";
import Loading from "@/components/common/loading";
import Select from '@/components/common/select'
import EventBus from '@/utils/EventBus';
export default {
  mixins: [languageMixins, errorDeviceMinxins, printMixins],
  components: {
    ButtonCommon,
    DatePicker,
    Pagination,
    Select,
    Loading
  },
  data() {
    return {
      filterDescription: "",
      itemsDescription: null,
      dataHistory: [],
      activeFillter: false,
      activeSearch: false,
      isLoadingSearch: false,
      isLoadingFilter: false,
      isLoadingScreens: false,
      current_page: 1,
      total_page: 0,
      per_page: 10,
      ticketID: '',
      dateFrom: '',
      dateTo: '',
    };
  },
  created() {
    // parse slugs data to select's model
    let status = this.$store.state.configAccount?.ticketStatusSlugs;
    if (!status) {
      this.itemsDescription = [
        { key: 'purchased', value: 'Purchased' },
        { key: 'cancelled', value: 'Cancelled' },
        { key: 'win', value: 'Win' },
        { key: 'lose', value: 'Lose' },
        { key: 'validated-win', value: 'Validated - Win' },
        { key: 'validated-cancelled', value: 'Validated - Cancelled' }
      ]
    } else {
      status.forEach(function (obj) {
        obj.key = obj.slug;
        obj.value = obj.name;
        // delete obj.slug;
        // delete obj.name;
      });
      this.itemsDescription = status;
    }
    this.fetchData();
    this.$store.dispatch('fetchDataConfig').then((res) => {
      this.checkErrorDevice(this.$router, res)
    }).catch((err) => {
      this.checkErrorDevice(this.$router, err)
    })
  },
  computed: {
    isDisableSearch() {
      return !(this.ticketID || this.dateFrom || this.dateTo);
    }
  },
  mounted() {
    document.addEventListener('message', this.handlePrintMessage)
  },
  beforeDestroy() {
    document.removeEventListener('message', this.handlePrintMessage)
  },
  methods: {
    handlePrintMessage(event) {
      // example to handle print status (success, error)
      const resp = JSON.parse(event.data)
      if (resp.type === 'print-success') {
        this.isReprinting = false
        // alert('print success')
      }
      else if (resp.type === 'print-error') {
        this.isReprinting = false
        // alert(resp.errorMessage)
      }
    },
    handleInputSearch(event) {
      this.ticketID = event.target.value.trim();
    },
    renderPrice(price) {
      return formatPrice(price);
    },
    async fetchData(page) {
      page ? this.current_page = page : page
      try {
        this.isLoadingScreens = true;
        const res = await HistoryService.getHistory(
          this.current_page,
          this.per_page,
          this.ticketID,
          this.dateFrom,
          this.dateTo,
          this.filterDescription.toLowerCase()
        );
        if (res.status === "success") {
          this.dataHistory = res.data.entries;
          this.total_page = Math.ceil(res.data.total / this.per_page);
        } else {
          this.handleShowError(res)
        }
        this.isLoadingSearch = false;
        this.isLoadingFilter = false;
        this.isLoadingScreens = false;
        this.checkErrorDevice(this.$router, res)
      } catch (error) {
        this.handleShowError(error)
        this.isLoadingSearch = false;
        this.isLoadingFilter = false;
        this.isLoadingScreens = false;
        this.checkErrorDevice(this.$router, error)
      }
    },
    async getReprintData(transactionId) {
      try {
        this.isReprinting = true;
        const res = await HistoryService.getReprintData(transactionId);
        if (res.status === "success") {
          return res.data;
        }
        this.handleShowError(res)
        this.checkErrorDevice(this.$router, res)
        return false;
      } catch (error) {
        this.handleShowError(error)
        this.checkErrorDevice(this.$router, error)
        return false;
      }
    },
    handleShowError(error) {
      const param = {
        title: '',
        status: "error",
      };
      param.title = error.data?.errors
        ? error.data.errors.map(item => item.message).join(', ')
        : error.message;
      EventBus.$emit("on-show-notications", param);
    },
    handlePageChange(page) {
      this.current_page = page
    },
    actionSearch() {
      this.fetchData(1);
      this.activeSearch = true;
      this.isLoadingSearch = true;
    },
    actionFilter() {
      this.fetchData(1);
      this.activeFillter = true;
      this.isLoadingFilter = true;
    },
    resetFilter() {
      if (this.filterDescription || !this.isDisableSearch) {
        this.ticketID = '';
        this.dateFrom = '';
        this.dateTo = '';
        this.filterDescription = '';
        EventBus.$emit("ChangeData", '')
        if (this.activeFillter || this.activeSearch) {
          this.fetchData(1);
          this.activeSearch = false;
          this.activeFillter = false;
        }
      }
    },
    async onReprintClicked(transactionId) {
      if (this.isReprinting) return;
      // call api to get reprint data
      // show error if api return error
      let data = await this.getReprintData(transactionId);
      if (data !== false && !data) {
        this.handleShowError({ message: 'Could not found reprint data of this ticket!' });
        this.isReprinting = false;
      } else {
        let printData = await this.prepareLogoAsSingleObject(data);
        if (printData) {
          parent.postMessage({ command: 'print-ticket-again', data: printData, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont }, '*')
        } else {
          this.isReprinting = false;
        }
      }
    }
  },
  watch: {
    current_page() {
      this.fetchData();
    },
    isDisableSearch() {
      if (this.isDisableSearch && this.activeSearch) {
        this.fetchData();
        this.activeSearch = false
      }
    }
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/history/_index.scss";
</style>
